import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    resultTable: {
        margin: '10px 25px 25px 25px !important',
        width: "75% !important",
    },
    resultHeader: {
        backgroundColor: theme.palette.header,
        color: theme.palette.text.primary,
    },
    checkbox: {
        display: "inline-flex",
        gap: 8,
        alignItems: "center"
    },
}));